module.exports = __webpack_public_path__ + "static/media/TrashJoes-logo.9893c4ed.png";